var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from "../Util";
import Tooltip from "../Tooltip";
var Badge = function (_a) {
    var type = _a.type, icon = _a.icon, content = _a.content, tooltip = _a.tooltip;
    var BadgeIcon = icon;
    var bgColor;
    var textColor;
    switch (type) {
        case "green":
            bgColor = "bg-green-100";
            textColor = "text-green-800";
            break;
        case "red":
            bgColor = "bg-red-100";
            textColor = "text-red-800";
            break;
        case "gray":
            bgColor = "bg-gray-100";
            textColor = "text-gray-800";
            break;
    }
    return (_jsxs("span", __assign({ "data-tip": tooltip && tooltip, className: classNames("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium", bgColor, textColor, tooltip ? "cursor-help" : "") }, { children: [BadgeIcon && _jsx(BadgeIcon, { width: 15, className: "mr-1" }), content, tooltip && _jsx(Tooltip, {})] })));
};
export default Badge;
